export const LIST_TRACKER_ACCOUNTS = 'BT_LIST_ACCOUNTS';
export const STORE_TRACKER_ACCOUNTS = 'BT_STORE_ACCOUNTS';
export const STORE_TRACKER_ACCOUNT = 'BT_STORE_ACCOUNT';
export const MARK_TRACKER_ACCOUNT_CANCELLED = 'BT_MARK_ACCOUNT_CANCELLED';
export const REMOVE_TRACKER_ACCOUNT = 'BT_REMOVE_ACCOUNT';

export const SAVE_TRACKER_ACCOUNT = 'BT_SAVE_ACCOUNT';
export const CANCEL_TRACKER_ACCOUNT = 'BT_CANCEL_ACCOUNT';
export const DELETE_TRACKER_ACCOUNT = 'BT_DELETE_ACCOUNT';
export const SAVE_TRACKER_CELL = 'BT_SAVE_CELL';
